import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mx-5 my-7" }
const _hoisted_2 = { class: "team-detail pt-3 px-40" }
const _hoisted_3 = {
  key: 0,
  class: "mb-5 font-bold"
}
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col items-center my-10"
}
const _hoisted_5 = { class: "w-2/3" }
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = { class: "my-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AudioScoresVisualizer = _resolveComponent("AudioScoresVisualizer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.audioDetails?.companyProjectId)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: _normalizeClass(['primary-button', 'mx-3']),
            to: `/projects/${_ctx.audioDetails?.companyProjectId}/details`
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Project ")
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.audioDetails?.fileName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.audioDetails.fileName) + " - Audio Analysis ", 1))
        : _createCommentVNode("", true),
      (_ctx.audioDetails)
        ? (_openBlock(), _createBlock(_component_AudioScoresVisualizer, {
            key: 1,
            audioDetails: _ctx.audioDetails
          }, null, 8, ["audioDetails"]))
        : _createCommentVNode("", true),
      (_ctx.audioDetails?.transcriptionJson)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTranscriptionVisibility && _ctx.toggleTranscriptionVisibility(...args))),
                  class: "text-button-font py-2.5 px-5 mr-2 mt-10 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                }, _toDisplayString(_ctx.showTranscription ? 'Hide transcription' : 'Show transcription'), 1)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.audioDetails?.transcriptionJson || '[]')
                            .map((item) => item.text), (line) => {
                  return (_openBlock(), _createElementBlock("span", null, [
                    _createTextVNode(_toDisplayString(line) + " ", 1),
                    _hoisted_8
                  ]))
                }), 256))
              ], 512), [
                [_vShow, _ctx.showTranscription]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}